import http from '@/http'
import LicensedPlan from '@/store/models/LicensedPlan'

const API_PATH = 'organizations/:organizationId/admin/account/license_plan/'

const configureApiPath = ({ organizationId }) => {
  return API_PATH.replace(':organizationId', organizationId)
}

const state = {
}

const getters = {
}

const mutations = {
}

const actions = {
  async validateChangable({ commit, rootGetters }, payload) {
    const apiPath = configureApiPath({ organizationId: rootGetters['auth/currentOrganization'].id })
    const params = JSON.stringify({
      licensePlan: payload
    })
    await http.post(apiPath + 'validate_changable', params).catch(error => {
      commit('setHttpError', error, { root: true })
    })
  },
  async update({ commit, rootGetters }, payload) {
    const apiPath = configureApiPath({ organizationId: rootGetters['auth/currentOrganization'].id })
    const params = JSON.stringify({
      licensePlan: payload
    })
    await http.put(apiPath, params).then(response => {
      LicensedPlan.deleteAll()
      LicensedPlan.insert({
        data: Object.assign(response.data.included.filter(resource => resource.type === 'licensedPlan' && resource.attributes.organizationId == rootGetters['auth/currentOrganization'].id).map(licensedPlan => licensedPlan.attributes)[0], {
          roomPlanMasters: response.data.included.filter(resource => resource.type === 'licensedRoomPlan' && resource.attributes.organizationId == rootGetters['auth/currentOrganization'].id).map(licensedRoomPlan => licensedRoomPlan.attributes),
          seatPlanMasters: response.data.included.filter(resource => resource.type === 'licensedAdditionalSeatPlan' && resource.attributes.organizationId == rootGetters['auth/currentOrganization'].id).map(licensedAdditionalSeatPlan => licensedAdditionalSeatPlan.attributes)
        })
      })
    }).catch(error => {
      commit('setHttpError', error, { root: true })
    })
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
